import React from 'react';

import StatementFamily from './StatementFamily';

export default (props) => {
  const lesson = props.lesson;
  const family = lesson.family;

  switch (family) {
    case 'impact':
      return (
        <StatementFamily lesson={lesson} editable={props.editable} dispatch={props.dispatch} />
      );
    default:
      return null;
  }
};
